import axios, { AxiosInstance } from 'axios';
import { store } from '../store';
import { logout, sessionExpired } from '../store/slices/auth.slice';
const baseUrl = import.meta.env.VITE_MINDRIGHT_API_ENDPOINT;

const authorizedInstance: AxiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

authorizedInstance.interceptors.request.use(
  (config) => {
    const { auth } = store.getState();

    if (auth.isAuthenticated && auth.token) {
      config.headers.Authorization = `${auth.token}`;
    }

    return config;
  },
  (error) => {
    console.error('Intercepted request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors
authorizedInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { auth } = store.getState();

    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
      store.dispatch(sessionExpired());
    } else if (!error.response && auth.isAuthenticated && error.code === 'ERR_NETWORK') {
      // CORS blocks the response on 401, so error.response is undefined.
      // Treat network errors while authenticated as an expired session.
      store.dispatch(logout());
      store.dispatch(sessionExpired());
    }

    return Promise.reject(error);
  }
);

export default authorizedInstance;
